export default "__VITE_ASSET__92078b05__"